import { getToday } from "utils/date";
import type { PeriodType } from "types/ManagerPayment";

export const PERIOD_COUNT: Record<PeriodType, number> = {
  daily: 7,
  weekly: 6,
  monthly: 6,
};

// yyyy-MM-dd 문자열은 사전순 비교 = 날짜 비교
const capToToday = (date: string): string => {
  const today = getToday();
  return date > today ? today : date;
};

export const toReferenceDate = (
  mode: PeriodType,
  searchDate: string
): string => {
  switch (mode) {
    case "daily":
      return searchDate;
    case "weekly":
      return capToToday(
        (new Date(searchDate) as any).getEndDateInWeek().getCalendar()
      );
    case "monthly":
      return capToToday(
        (new Date(searchDate) as any).getEndDateInMonth().getCalendar()
      );
  }
};
